export const routes={
    ROOT:'/',
    IDE:'/ide',
    NOTEBOOK:'/notebook',
}